module.exports = __webpack_public_path__ + "img/MAX-CHANCE.c799f752.png";